module.exports = __webpack_public_path__ + "img/2-8.5de0a580.png";